export enum POSPurchaseFlowType {
  SeatsFirst = 0,
  TicketsFirst = 1,
}
